// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLaserStandby_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 4C13.1046 4 14 3.10457 14 2C14 0.895431 13.1046 0 12 0C10.8954 0 10 0.895431 10 2C10 3.10457 10.8954 4 12 4Z" class="svg-bg"/>
  <path d="M21.5 12.5C21.5 8.53356 19.0692 5.13486 15.616 3.71239C15.8622 3.1933 16 2.61274 16 2C16 1.9028 15.9965 1.8064 15.9897 1.71093C20.3744 3.33294 23.5 7.55146 23.5 12.5C23.5 18.8513 18.3513 24 12 24C5.64873 24 0.5 18.8513 0.5 12.5C0.5 7.55146 3.62559 3.33294 8.01028 1.71093C8.00347 1.8064 8 1.90279 8 2C8 2.61274 8.13777 3.1933 8.38403 3.71239C4.93083 5.13486 2.5 8.53356 2.5 12.5C2.5 17.7467 6.75329 22 12 22C17.2467 22 21.5 17.7467 21.5 12.5Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16 6C17.6569 6 19 4.65685 19 3C19 1.34315 17.6569 0 16 0C14.3431 0 13 1.34315 13 3C13 4.65685 14.3431 6 16 6Z" class="svg-bg"/>
  <path d="M21 3.00074C21 3.65593 20.874 4.28169 20.6449 4.8551C25.5306 6.72469 29 11.4576 29 17.0007C29 24.1804 23.1797 30.0007 16 30.0007C8.8203 30.0007 3 24.1804 3 17.0007C3 11.4576 6.46937 6.72469 11.3551 4.8551C11.126 4.28169 11 3.65593 11 3.00074C11 2.95149 11.0007 2.90242 11.0021 2.85352C5.17505 4.9121 1 10.4688 1 17.0007C1 25.285 7.71573 32.0007 16 32.0007C24.2843 32.0007 31 25.285 31 17.0007C31 10.4688 26.8249 4.9121 20.9979 2.85352C20.9993 2.90242 21 2.95149 21 3.00074Z" class="svg-bg"/>
</svg>
`;
const _s64IconSvg = html `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M32 18C33.6569 18 35 16.6569 35 15C35 13.3431 33.6569 12 32 12C30.3431 12 29 13.3431 29 15C29 16.6569 30.3431 18 32 18Z" class="svg-bg"/>
  <path d="M37 15.001C37 15.5838 36.9003 16.1433 36.717 16.6634C43.8111 18.708 49 25.2482 49 33.0004C49 42.3893 41.3888 50.0004 32 50.0004C22.6112 50.0004 15 42.3893 15 33.0004C15 25.2482 20.1889 18.708 27.283 16.6634C27.0997 16.1433 27 15.5838 27 15.001C27 14.8871 27.0038 14.7741 27.0113 14.6621C18.9379 16.8532 13 24.2334 13 33.0004C13 43.4938 21.5066 52.0004 32 52.0004C42.4934 52.0004 51 43.4938 51 33.0004C51 24.2334 45.0621 16.8532 36.9887 14.6621C36.9962 14.7741 37 14.8871 37 15.001Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedLaserStandby is a generated icon component.
 */
let IconMedLaserStandby = IconMedLaserStandby_1 = class IconMedLaserStandby extends IconBaseElement {
    render() {
        return html `${IconMedLaserStandby_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLaserStandby.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s64IconSvg],
    ['s48', _s64IconSvg],
    ['s64', _s64IconSvg],
    ['s72', _s64IconSvg],
    ['s80', _s64IconSvg],
]);
IconMedLaserStandby = IconMedLaserStandby_1 = __decorate([
    customElement('zui-icon-med-laser-standby')
], IconMedLaserStandby);
export { IconMedLaserStandby };
